import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { formatNumber } from 'libphonenumber-js';
import { CountriesService } from '../../services/countries.service';
import { ShowStoryService } from '../show/show.service';

@Component({
  selector: 'order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  @Input() order;
  storyCover;
  storyError = false;
  coverLoaded = false;

  isDetailsExpanded = false;

  constructor(
    private countriesService: CountriesService,
    private showStoryService: ShowStoryService,
  ) { }

  ngOnInit() {
    this.getBookCover();
  }

  handleToggleDetails() {
    this.isDetailsExpanded = !this.isDetailsExpanded;
  }

  getOrderDate() {
    return moment(this.order.created_at).toDate();
  }

  isCoverLoaded(){
    this.coverLoaded = true;
  }

  getBookCover() {
    if (this.order.story) {
        this.showStoryService.getStoryCover(this.order.story.id).subscribe(cover => {
        this.storyCover = cover;
      });
    } else {
      this.storyError = true;
    }

  }

  isDiscountExists() {
    return parseFloat(this.order.discount_price);
  }

  isTaxExists() {
    return parseFloat(this.order.tax_price);
  }

  displayZipAndCity() {
    if (this.order.shipping_address.country_code === 'US') {
      return `${this.order.shipping_address.city} ${this.order.shipping_address
        .zip_code}`;
    } else {
      return `${this.order.shipping_address.zip_code} ${this.order
        .shipping_address.city}`;
    }
  }

  displayCountry() {
    const code = this.order.shipping_address.country_code;
    return this.countriesService.get(code).name;
  }

  formatNumber(number) {
    return formatNumber(number, 'International');
  }
}
